import React, { useState, useEffect } from 'react';
import Services from '../services/services';
import Seat from '../ui/Seat';
import SeatParticipants from '../ui/SeatParticipants';
import CustomButton from '../ui/viewEventUi/CustomButton';
import addParticipantStyles from '../styles/addParticipantStyles';
import BodyContainer from '../ui/BodyContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import EventSeatSharpIcon from '@material-ui/icons/EventSeatSharp';
import Select from 'react-select';
import toast, { Toaster } from 'react-hot-toast';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateSeats, clearAll } from '../redux/seatInfoSlice';
import { isEmail } from '../regexFuncs';
import { getUserBrowserStorage } from '../constants';
import { backArrow } from '../ui/icons';

const useStyles = makeStyles((theme) => addParticipantStyles(theme));

function AddParticipants() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const seatInfo = useSelector((state) => state.seatInfo);
  const location = useLocation();
  const history = useHistory();
  const eventData = location.state.data;
  const dataFrom = location.state.dataFrom;
  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const [apiReserveCall, setApiReserveCall] = useState(false);
  const [seatsArr, setSeatsArr] = useState([]);
  const [selectedBox, setSelectedBox] = useState(null);
  const [boxValues, setBoxValues] = useState(null);
  const [newValue, setNewValue] = useState(false);
  const [boxIdFromApi, setBoxIdFromApi] = useState(null);

  const title =
    dataFrom === 'UpcomingEvents' ? 'Select Seats' : 'Add Participants';

  const getBoxesOwned = () => {
    if (dataFrom === 'UpcomingEvents' || dataFrom === 'HostedEvents') {
      getBoxDetails();
    } else {
      const boxValues = eventData.assignBoxes.map((data) => {
        return {
          value: data.boxName,
          label: data.boxName,
          boxPrice: data.boxPrice,
          boxId: data.boxId,
        };
      });
      setBoxValues(boxValues);
    }
  };

  const getBoxApiCall = async () => {
    try {
      const res = await Services.get_box_details(
        userDetails?.userId,
        eventData.eventId
      );
      return res.data.Boxes;
    } catch (error) {
      return false;
    }
  };

  const getBoxDetails = async () => {
    try {
      const res = await getBoxApiCall();
      if (res) {
        const getBoxType = res.reduce((accumulator, currentVal) => {
          if (currentVal.isBoxPublic === true) {
            const oneBox = {
              value: currentVal.boxName,
              label: currentVal.boxName,
              boxPrice: currentVal.boxPrice,
              boxId: currentVal.boxId,
            };
            return [...accumulator, oneBox];
          } else {
            return [...accumulator];
          }
        }, []);
        setBoxValues(getBoxType);
      }
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    getBoxesOwned();
    setNewValue(true);
  }, []);

  // useEffect(() => {
  //   totalSeatCheckout();
  // }, [seatInfo]);

  // const totalSeatCheckout = () => {
  //   seatInfo?.forEach((number) => {
  //     number.seatPrice += number.seatPrice;
  //     const value = number.seatPrice;
  //   });
  // };

  const getSeatDetails = async (eventId, boxId) => {
    const toastId = toast.loading('Loading seats..');
    try {
      const res = await Services.seat_Info(eventId, boxId);
      if (res.data.responseCode === 200) {
        toast.success('Select seats', { duration: 2000, id: toastId });
        await setSeatsArr(res.data.seatNumber);
      } else {
        toast.error('Error! Try again.', { duration: 4000, id: toastId });
      }
    } catch (error) {
      toast.error('Error! Try again.', { duration: 4000, id: toastId });
    }
  };

  const boxMovingApi = async (box) => {
    const movingDetails = {
      userId: userDetails?.userId,
      eventId: eventData.eventId,
      boxName: box?.value,
      boxId: null,
    };
    const boxMovingRes = await Services.box_moving(movingDetails);
    const boxId = boxMovingRes.data.boxDetails.newBoxId;
    setBoxIdFromApi(boxId);
    getSeatDetails(eventData.eventId, boxId);
  };

  const funcGetAndCheckBoxId = async (box) => {
    const updatedBoxes = await getBoxApiCall();
    const match =
      updatedBoxes &&
      (await updatedBoxes?.find((newBox) => {
        if (newBox['boxName'] === box?.value) {
          const res = newBox['boxId'] ? true : false;
          return res;
        } else {
          return false;
        }
      }));
    if (match) {
      getSeatDetails(eventData.eventId, match['boxId']);
      return;
    } else {
      boxMovingApi(box);
    }
  };

  useEffect(() => {
    dispatch(clearAll());
    if (!selectedBox?.boxId && newValue) {
      funcGetAndCheckBoxId(selectedBox);
    } else {
      selectedBox?.boxId &&
        getSeatDetails(eventData.eventId, selectedBox.boxId);
    }
  }, [selectedBox]);

  const handleSeatClick = (seat, selected) => {
    dispatch(updateSeats({ seat, selected }));
  };

  const setBoxSelection = (selectedOption) => {
    setSelectedBox(selectedOption);
  };

  const checkFieldsEntered = () => {
    //combine .every and .map in future -- no multiple iterations
    const allFields = seatInfo.selectedSeats.every((seatDetail) => {
      const email = isEmail(seatDetail.email);
      const name = seatDetail.name?.length !== 0;
      const paymentStatus = seatDetail.paymentStatus?.length ? true : false;
      const nameAndPaymentStatus = name && paymentStatus;
      return nameAndPaymentStatus && email;
    });
    const allEmail = seatInfo.selectedSeats.map((seatDetail) => {
      return seatDetail.email;
    });
    const removedDupeEmails = new Set(allEmail);
    const hasDupeEmails = removedDupeEmails.size < allEmail.length;
    const allowApiCall = allFields && !hasDupeEmails;
    return { allowApiCall, hasDupeEmails, allFields };
  };

  const reserveFunc = async () => {
    const toastId = toast.loading('loading..');
    const { allowApiCall, hasDupeEmails, allFields } = checkFieldsEntered();
    if (seatInfo.selectedSeats.length && allowApiCall) {
      try {
        setApiReserveCall(true);
        const res = await Services.add_participants({
          boxId: selectedBox?.boxId || boxIdFromApi,
          isBoxPublic:
            dataFrom === 'UpcomingEvents' || dataFrom === 'HostedEvents'
              ? 1
              : 0,
          seatInfo: seatInfo.selectedSeats,
        });

        //seatInfo.selectedSeats

        if (res.data.responseCode === 201) {
          toast.success(res.data.details, { duration: 4000, id: toastId });
          history.push('/');
        } else {
          setApiReserveCall(false);
          toast.error(res.data.details, { duration: 4000, id: toastId });
        }
      } catch (error) {
        setApiReserveCall(false);
        toast.error('Failed to reserve', { duration: 4000, id: toastId });
      }
    } else {
      setApiReserveCall(false);
      if (!allFields) {
        toast.dismiss();
        toast.error('Please fill all valid details', {
          duration: 4000,
          id: toastId,
        });
      } else if (hasDupeEmails) {
        toast.dismiss();
        toast.error('Emails should be unique.', {
          duration: 4000,
          id: toastId,
        });
      } else {
        toast.dismiss();
        toast.error('Please check entries.', { duration: 4000, id: toastId });
      }
    }
  };

  const handleBackButton = () => {
    history.goBack();
  };

  return (
    <BodyContainer title={title} icon={backArrow(handleBackButton)}>
      <Grid container className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <Select
            value={selectedBox}
            options={boxValues}
            placeholder='Choose Box'
            styles={customStyles}
            onChange={setBoxSelection}
          />
          <br />
          <div className={classes.seatsContainer}>
            {seatsArr.map((seat) => {
              return (
                <Seat
                  key={seat.seatName + selectedBox?.boxId}
                  handleSeatClick={handleSeatClick}
                  seat={seat}
                />
              );
            })}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column-reverse',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <SeatParticipants
              eventId={eventData?.eventId}
              boxId={selectedBox?.boxId || boxIdFromApi}
              isHavingSeatPrice={!!eventData?.seatPrice}
              isPaymentReq={
                dataFrom === 'UpcomingEvents' || dataFrom === 'HostedEvents'
              }
            />
          </div>
          <div style={{ height: 2 }} />
          <CustomButton
            btnStyle={classes.button}
            clickHandle={apiReserveCall ? () => null : reserveFunc}
            btnText={'Reserve'}
          />
          <div className={classes.legendContainer}>
            <Typography variant='caption' gutterBottom>
              *Please choose a box and select seats
            </Typography>
            <div className={classes.legendContent}>
              <EventSeatSharpIcon className={classes.filled} />
              <Typography variant='caption'>&nbsp; -Filled</Typography>
            </div>
            <div className={classes.legendContent}>
              <EventSeatSharpIcon className={classes.selected} />
              <Typography variant='caption'>&nbsp; -Selected</Typography>
            </div>
            <div className={classes.legendContent}>
              <EventSeatSharpIcon className={classes.empty} />
              <Typography variant='caption'>&nbsp; -Empty</Typography>
            </div>
          </div>
        </Paper>
        <Toaster position='top-center'></Toaster>
      </Grid>
    </BodyContainer>
  );
}

export default AddParticipants;

const customStyles = {
  container: (state) => ({
    ...state,
    width: 140,
  }),
  menu: (state) => ({
    ...state,
    zIndex: 2,
    marginTop: 0,
    marginBottom: 0,
  }),

  control: (base) => ({
    ...base,
    height: 40,
    width: '100%',
    flex: 1,
    borderColor: '#0000003b',
    borderWidth: 2,
    borderStyle: 'solid',
    marginTop: '10px',
    marginBottom: '5px',
    borderRadius: '8px',
  }),

  placeholder: (state) => ({
    position: 'absolute',
    color: 'grey',
    fontSize: '1rem',
  }),
  indicatorsContainer: (state) => ({
    position: 'absolute',
    right: 0,
    // fill: '#000',
  }),
  singleValue: (state) => ({
    position: 'absolute',
    fontSize: '1rem',
    // top: 4,
  }),
};
